import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import MultiButtonDialogModal from '../../../../modals/MultiButtonDialogModal';
import UploadFilesModal from '../../../../modals/UploadFilesModal';
import UploadDocumentsModal from '../../../../modals/UploadDocumentsModal';
import ChooseFromLibraryModal from '../../../../modals/ChooseFromLibraryModal';

const UploadModals = forwardRef(({
  handleImageUpload,
  handleDocumentUpload,
  handleVideoUpload,
  handleLibrarySelection,
}, ref) => {
  // Upload modal state - moved from parent
  const [isImportFileChoiceVisible, setIsImportFileChoiceVisible] = useState(false);
  const [isUploadImagesModalVisible, setIsUploadImagesModalVisible] = useState(false);
  const [isUploadDocumentsModalVisible, setIsUploadDocumentsModalVisible] = useState(false);
  const [isChooseFromLibraryVisible, setIsChooseFromLibraryVisible] = useState(false);
  const [chooseLibraryInitialTab, setChooseLibraryInitialTab] = useState('mobile uploads');
  const videoFileInputRef = useRef();

  // Expose modal state setters for AddSectionMenu
  useImperativeHandle(ref, () => ({
    setIsImportFileChoiceVisible,
    setIsUploadImagesModalVisible,
    setIsUploadDocumentsModalVisible,
  }));

  return (
    <>
      {/* Import/Upload modals for parity */}
      <MultiButtonDialogModal
        show={isImportFileChoiceVisible}
        handleClose={() => setIsImportFileChoiceVisible(false)}
        title={
          <>
            Where are you importing from?
          </>
        }
        buttons={[
          {
            title: 'Mobile Uploads',
            handleClick: () => {
              setIsImportFileChoiceVisible(false);
              setChooseLibraryInitialTab('mobile uploads');
              setIsChooseFromLibraryVisible(true);
            },
            color: '',
          },
          {
            title: 'Saved Sections',
            handleClick: () => {
              setIsImportFileChoiceVisible(false);
              setChooseLibraryInitialTab('saved');
              setIsChooseFromLibraryVisible(true);
            },
            color: 'black',
          },
          {
            title: 'My Computer',
            handleClick: () => {
              setIsImportFileChoiceVisible(false);
              videoFileInputRef.current?.click();
            },
            color: '#FDB258',
          },
        ]}
      />
      <UploadFilesModal
        withText
        show={isUploadImagesModalVisible}
        handleClose={() => setIsUploadImagesModalVisible(false)}
        onSubmit={async ({ files, descriptions }) => {
          await handleImageUpload(files, descriptions);
        }}
      />
      <UploadDocumentsModal
        show={isUploadDocumentsModalVisible}
        handleClose={() => setIsUploadDocumentsModalVisible(false)}
        onSubmit={async ({ files }) => {
          await handleDocumentUpload(files);
        }}
      />
      <ChooseFromLibraryModal
        show={isChooseFromLibraryVisible}
        initialTab={chooseLibraryInitialTab}
        onClose={() => setIsChooseFromLibraryVisible(false)}
        onConfirm={async (items) => {
          await handleLibrarySelection(items);
          setIsChooseFromLibraryVisible(false);
        }}
      />
      <input
        ref={videoFileInputRef}
        type="file"
        accept="video/*"
        multiple
        style={{ display: 'none' }}
        onChange={async (e) => {
          const files = Array.from(e.target.files || []);
          if (!files.length) return;
          await handleVideoUpload(files);
          e.target.value = '';
        }}
      />
    </>
  );
});

UploadModals.displayName = 'UploadModals';

export default UploadModals;

